"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, findAllIn, find, closest, findIn, hasClass, removeClass, removeAttribute, addClass} from "@elements/dom-utils";
import asyncAppend from "@elements/async-append";
import Collapse from 'bootstrap/js/dist/collapse';
import axios from "axios";

export function init () {
    let colsPerRow = 3;

    if (matchMedia('(max-width: 767px)').matches) {
        colsPerRow = 2;
    }

    onFind('.js-product-collapse', (container) => {
        findAllIn('.js-product-collapse__col-toggle', container).map((toggleButton, index) => {
            on('click', () => {
                let target = find(toggleButton.getAttribute('data-bs-target')),
                    col = closest('.js-product-collapse__col', toggleButton),
                    collapseInstance = Collapse.getOrCreateInstance(target, {toggle: false});

                let pendingRequest = axios({method: 'GET', url: toggleButton.getAttribute('data-content-url')});

                if (hasClass('is-collapsed', col)) {
                    removeClass('is-collapsed', col);
                } else {
                    findAllIn('.js-product-collapse__col', container).map((col) => {
                        removeClass('is-collapsed', col);
                    });

                    addClass('is-collapsed', col);
                }

                asyncAppend({
                    target: findAllIn('.js-product-collapse__content', target),
                    loading: findAllIn('.js-product-collapse__loading', target)
                }, pendingRequest.then(({data}) => {
                    //timeout prevents content jump
                    let t = setTimeout(() => {
                        collapseInstance.toggle();

                        clearTimeout(t);
                    }, 10)

                    return data
                }));

                on('shown.bs.collapse', () => {
                    window.scrollTo({
                        top: col.getBoundingClientRect().top + window.scrollY,
                        behavior: 'smooth'
                    });
                }, target);
            }, toggleButton);
        });
    });
}

function getElementIndex (element) {
    return [...element.parentNode.children].indexOf(element);
}